<div id="forgetpassword" fxLayout="column">
    <div class="custom-top-nav py-2">
        <img class="page-giant-logo border-1 mx-3" width="140" src="../../../../assets/images/logo/giant2.png">
    </div>
    <div class="company-info py-2 text-center"><h5 class="m-0">Enter email to reset password</h5></div>
    <div id="forgetpassword-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <div id="forgetpassword-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
            <!-- <div class="logo">
                <img src="../../../../assets/images/logo/giant2.png">
            </div> -->
            <form name="forgetpasswordForm" [formGroup]="forgetpasswordForm" novalidate>               
                <mat-form-field appearance="outline">
                    <!-- <mat-label>Email</mat-label> -->
                    <input matInput formControlName="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" placeholder="Email">
                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                    <mat-error *ngIf="forgetpasswordForm.get('email').hasError('required')"> Email is required </mat-error>
                    <mat-error *ngIf="!forgetpasswordForm.get('email').hasError('required') && forgetpasswordForm.get('email').hasError('email')"> Email is required </mat-error>
                    <mat-error *ngIf="forgetpasswordForm.get('email').errors?.pattern && forgetpasswordForm.get('email').touched">Email is Invalid</mat-error>
                </mat-form-field>

                <button mat-raised-button color="accent" class="submit-button" aria-label="Forget password" style="background-color: #36639f; color: #fff;; cursor: pointer; width: 100%; margin-bottom: 5px;" [disabled]="forgetpasswordForm.invalid" (click)="VerifyUserEmail(forgetpasswordForm)">
                    Submit
                </button>

            </form>

        </div>

    </div>

</div>
